import type { ValueOf } from 'cpool-utils';

export const CHAT_NUMBER_STATUSES = {
    CURRENT: 'current',
    FOREIGN: 'foreign',
    UNAVAILABLE: 'unavailable',
} as const;

export type ChatNumberStatus = ValueOf<typeof CHAT_NUMBER_STATUSES>;
